// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats_strip__s8TvM {
  background: var(--color-paper);
  border-bottom: 1px solid var(--color-border);
  font-family: var(--font-sans);
  padding-inline: var(--gutter);
}
.stats_list__6NDQO {
  max-width: var(--container);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.stats_stat__9hMjh {
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  gap: 0.35rem;
  padding: clamp(1.5rem, 1rem + 2vw, 2.75rem) var(--space-4);
  border-left: 1px solid var(--color-border);
}
.stats_stat__9hMjh:nth-child(odd) {
  border-left: 0;
  padding-left: 0;
}
.stats_stat__9hMjh:last-child {
  grid-column: 1 / -1;
  border-left: 0;
  padding-left: 0;
  border-top: 1px solid var(--color-border);
}
.stats_value__UQoky {
  margin: 0;
  font-size: clamp(2.4rem, 1.6rem + 3vw, 4rem);
  line-height: 1;
  font-weight: 500;
  letter-spacing: var(--tracking-figure);
  color: var(--color-ink);
  font-variant-numeric: tabular-nums;
}
.stats_label__VCJFt {
  margin: 0;
  font-size: var(--text-caption);
  letter-spacing: 0.04em;
  color: var(--color-text-muted);
  font-weight: 500;
}
.stats_srOnly__rR6u2 {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

@media (min-width: 768px) {
  .stats_list__6NDQO {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .stats_stat__9hMjh,
  .stats_stat__9hMjh:nth-child(odd),
  .stats_stat__9hMjh:last-child {
    grid-column: auto;
    border-top: 0;
    border-left: 1px solid var(--color-border);
    padding-left: var(--space-5);
  }
  .stats_stat__9hMjh:first-child {
    border-left: 0;
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/STATS/stats.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,0DAA0D;EAC1D,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;;;IAGE,iBAAiB;IACjB,aAAa;IACb,0CAA0C;IAC1C,4BAA4B;EAC9B;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":[".strip {\n  background: var(--color-paper);\n  border-bottom: 1px solid var(--color-border);\n  font-family: var(--font-sans);\n  padding-inline: var(--gutter);\n}\n.list {\n  max-width: var(--container);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.stat {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: flex-end;\n  gap: 0.35rem;\n  padding: clamp(1.5rem, 1rem + 2vw, 2.75rem) var(--space-4);\n  border-left: 1px solid var(--color-border);\n}\n.stat:nth-child(odd) {\n  border-left: 0;\n  padding-left: 0;\n}\n.stat:last-child {\n  grid-column: 1 / -1;\n  border-left: 0;\n  padding-left: 0;\n  border-top: 1px solid var(--color-border);\n}\n.value {\n  margin: 0;\n  font-size: clamp(2.4rem, 1.6rem + 3vw, 4rem);\n  line-height: 1;\n  font-weight: 500;\n  letter-spacing: var(--tracking-figure);\n  color: var(--color-ink);\n  font-variant-numeric: tabular-nums;\n}\n.label {\n  margin: 0;\n  font-size: var(--text-caption);\n  letter-spacing: 0.04em;\n  color: var(--color-text-muted);\n  font-weight: 500;\n}\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n\n@media (min-width: 768px) {\n  .list {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n  .stat,\n  .stat:nth-child(odd),\n  .stat:last-child {\n    grid-column: auto;\n    border-top: 0;\n    border-left: 1px solid var(--color-border);\n    padding-left: var(--space-5);\n  }\n  .stat:first-child {\n    border-left: 0;\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip": `stats_strip__s8TvM`,
	"list": `stats_list__6NDQO`,
	"stat": `stats_stat__9hMjh`,
	"value": `stats_value__UQoky`,
	"label": `stats_label__VCJFt`,
	"srOnly": `stats_srOnly__rR6u2`
};
export default ___CSS_LOADER_EXPORT___;
